module.exports = __webpack_public_path__ + "img/foot.fa33e227.svg";